/*
 * ヘッダーの商品検索を「すべての言葉を含む」AND検索にする。
 *
 * Shopifyの通常の検索はAIによる意味の理解が働き、言葉を含まない商品まで結果に混ざる。
 * 検索構文(title: など)を使うとこれが働かなくなるため、送信時に検索語を
 *   神蔵 スパークリング
 *   → (title:神蔵 OR tag:神蔵) (title:スパークリング OR tag:スパークリング)
 * に書き換える(グループ同士はAND)。対象は商品名とタグのみで、説明文は含めない。
 * https://help.shopify.com/manual/online-store/storefront-search/search-behavior
 *
 * 検索ページでの表示用に元の言葉へ戻す処理は snippets/search-terms.liquid にある。
 */
(function () {
  // 構文として解釈されてしまう記号は取り除く
  var SYNTAX_CHARS = /[()":\\*]/g;

  function buildQuery(value) {
    return value
      .split(/[\s　]+/)
      .map(function (word) {
        return word.replace(SYNTAX_CHARS, '').replace(/^-+/, '');
      })
      .filter(Boolean)
      .map(function (word) {
        return '(title:' + word + ' OR tag:' + word + ')';
      })
      .join(' ');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[role="search"]')) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var query = buildQuery(input.value);
    if (!query) return;

    event.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', query);
    window.location.href = form.action + '?' + params.toString();
  });
})();
